import AddressName from "./AddressName";
import AddressLink from "./AddressLink";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const AddressDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="Address-detail-title"
                    >
                        { label || t`Address` }: <AddressName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="Address-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="Address-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } data-testid="address-label" sx={{ textAlign: "left" }}><Trans>Address</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="address-value" sx={{ textAlign: "left" }}>{ data.address || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="city-label" sx={{ textAlign: "left" }}><Trans>City</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="city-value" sx={{ textAlign: "left" }}>{ data.city || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="country-label" sx={{ textAlign: "left" }}><Trans>Country</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="country-value" sx={{ textAlign: "left" }}>{ data.country || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="email-label" sx={{ textAlign: "left" }}><Trans>Email</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="email-value" sx={{ textAlign: "left" }}>{ data.email || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="phone-label" sx={{ textAlign: "left" }}><Trans>Phone</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="phone-value" sx={{ textAlign: "left" }}>{ data.phone || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="mobilePhone-label" sx={{ textAlign: "left" }}><Trans>Mobile Phone</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="mobilePhone-value" sx={{ textAlign: "left" }}>{ data.mobilePhone || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="description-label" sx={{ textAlign: "left" }}><Trans>Description</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="description-value" sx={{ textAlign: "left" }}>{ data.description || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default AddressDetail;
